import { IncomingInvite } from './components/IncomingInvite.js';
import { ReconnectOverlay } from './components/ReconnectOverlay.js';
import { screenOf } from './game/session.js';
import { BracketScreen } from './screens/BracketScreen.js';
import { Finish } from './screens/Finish.js';
import { Home } from './screens/Home.js';
import { Leaderboard } from './screens/Leaderboard.js';
import { Lobby } from './screens/Lobby.js';
import { Shop } from './screens/Shop.js';
import { Match } from './screens/Match.js';
import { Onboarding } from './screens/Onboarding.js';
import { MatchEnd } from './screens/MatchEnd.js';
import { Search } from './screens/Search.js';
import { useApp } from './store.js';

const SPLASH = {
  starting: 'Выходим на поле…',
  outside: 'Откройте Penalty Cup в Telegram',
  denied: 'Сессия устарела. Закройте игру и откройте снова',
  offline: 'Нет связи с сервером. Попробуйте ещё раз',
  ready: 'Выходим на поле…',
} as const;

function Screens() {
  const screen = useApp(screenOf);
  const session = useApp((s) => s.session);

  switch (screen) {
    case 'onboarding':
      return <Onboarding />;
    case 'home':
      return <Home />;
    case 'leaderboard':
      return <Leaderboard />;
    case 'search':
      return <Search />;
    case 'shop':
      return <Shop />;
    case 'lobby':
      return <Lobby />;
    case 'bracket':
      return <BracketScreen />;
    case 'match':
      return <Match />;
    case 'matchEnd':
      return <MatchEnd />;
    case 'out':
      return <Finish out />;
    case 'finish':
      return <Finish />;
    default:
      return (
        <main className="splash">
          <div className="splash__ball" aria-hidden="true">
            ⚽
          </div>
          <h1 className="splash__title">Penalty Cup</h1>
          <p className="splash__status" role="status">
            {SPLASH[session]}
          </p>
        </main>
      );
  }
}

export function App() {
  return (
    <>
      <Screens />
      <ReconnectOverlay />
      <IncomingInvite />
    </>
  );
}
